(() => {
  document.addEventListener('click', async event => {
    const dismiss = event.target.closest('[data-cart-look-dismiss]');
    if (dismiss) { dismiss.closest('[data-cart-look]').hidden = true; return; }
    const button = event.target.closest('[data-cart-look-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const row = button.closest('[data-cart-look-item]');
    const select = row.querySelector('[data-cart-look-variant]');
    if (!select.value || select.selectedOptions[0]?.disabled) return;
    const error = row.querySelector('[data-cart-look-error]');
    error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:select.value,quantity:1}]})
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Não foi possível adicionar o item. Tente novamente.');
      if (typeof window.bndlr?.updateCartDiscounts === 'function') window.bndlr.updateCartDiscounts();
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    } catch (reason) { error.textContent = reason.message; error.hidden = false; }
    finally { button.disabled = false; button.removeAttribute('aria-busy'); }
  });
})();

/* Bundler Legacy: apply the validated code through Shopify's cart API. */
(() => {
  if (window.DaljiBundleCart) return;
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const managed = code => /^(?:(?:complete o look|leve junto[, ]+e? ?pague menos)|\[[a-z0-9]{7}\]$)/i.test(code || '');
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  let running, timer, revision = 0, lastSignature = '', pendingMutations = 0;
  const cartCodes = cart => {
    const codes = (cart.discount_codes || []).map(item => item.code);
    const allocations = [...(cart.cart_level_discount_applications || []),...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(value => value.discount_application))];
    allocations.filter(item => item?.type === 'discount_code').forEach(item => codes.push(item.title));
    return [...new Map(codes.filter(Boolean).map(code => [code.toLowerCase(),code])).values()];
  };
  const signature = cart => JSON.stringify({items:cart.items.map(item => [item.variant_id,item.quantity,item.properties,item.selling_plan_allocation?.selling_plan?.id]),codes:cartCodes(cart).map(code => code.toLowerCase()).sort()});
  const readCart = async () => {
    const response = await nativeFetch(`${root}cart.js`, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Não foi possível conferir o carrinho.');
    return response.json();
  };
  async function checkoutInfo() {
    const deadline = Date.now() + 12000;
    while (typeof window.bndlr?.getCheckoutInfo !== 'function') {
      if (Date.now() >= deadline) throw new Error('O Bundler ainda não carregou.');
      await delay(100);
    }
    return new Promise((resolve,reject) => {
      const timeout = setTimeout(() => reject(new Error('O Bundler não confirmou o desconto.')),15000);
      try {window.bndlr.getCheckoutInfo(data => {clearTimeout(timeout);resolve(data);});}
      catch (error) {clearTimeout(timeout);reject(error);}
    });
  }
  function refresh(cart) {
    if (window.FoxTheme?.pubsub) {
      window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart});
    } else document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:false}}));
  }
  async function reconcile() {
    while (pendingMutations) await delay(50);
    let cart = await readCart();
    if (signature(cart) === lastSignature) return cart;
    const initialSignature = signature(cart), initialRevision = revision;
    const codes = cartCodes(cart);
    const retained = codes.filter(code => !managed(code));
    let code = '';
    if (cart.item_count >= 2) {
      const info = await checkoutInfo();
      if (info?.can_apply_discount === true && typeof info.code === 'string' && info.code.trim().length > 0) code = info.code;
    }
    // Never apply a quote that was obtained for a previous item selection.
    const current = await readCart();
    if (initialRevision !== revision || initialSignature !== signature(current)) return null;
    const desired = [...retained,...(code ? [code] : [])];
    const unchanged = codes.length === desired.length && codes.every(value => desired.some(code => code.toLowerCase() === value.toLowerCase()));
    if (!unchanged) {
      const sections = [];
      document.dispatchEvent(new CustomEvent('cart:grouped-sections',{detail:{sections}}));
      const uniqueSections = [...new Set(sections)].slice(0,5);
      const payload = {discount:desired.join(',')};
      if (uniqueSections.length) {payload.sections=uniqueSections;payload.sections_url=location.pathname;}
      const response = await nativeFetch(`${root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      cart = await response.json();
      if (!response.ok || cart.status) throw new Error('Não foi possível confirmar o desconto no carrinho.');
      if (initialRevision !== revision) return null;
      // GET /cart.js and POST /cart/update.js can expose different code fields.
      lastSignature = signature(await readCart());
      refresh(cart);
    } else {cart=current;lastSignature=signature(cart);}
    document.documentElement.dataset.daljiBundleCart = 'ready';
    return cart;
  }
  function sync() {
    clearTimeout(timer);
    if (running) return running;
    document.documentElement.dataset.daljiBundleCart = 'updating';
    running = (async () => {
      let cart;
      do {cart=await reconcile();} while (cart === null);
      return cart;
    })().then(cart => {
      document.documentElement.dataset.daljiBundleCart = 'ready';
      return cart;
    }).catch(error => {
      document.documentElement.dataset.daljiBundleCart = 'error';
      console.warn('[Dalji] Desconto do look:',error.message);
      throw error;
    }).finally(() => {running=null;});
    return running;
  }
  function schedule() {
    clearTimeout(timer);
    timer=setTimeout(() => sync().catch(() => {}),150);
  }
  // Observe native theme additions, removals, quantities and manual coupons.
  window.fetch = function(input,options) {
    const url = typeof input === 'string' ? input : input?.url;
    const method = String(options?.method || input?.method || 'GET').toUpperCase();
    const mutation = method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(url || '');
    if (!mutation) return nativeFetch(input,options);
    pendingMutations++;revision++;
    return nativeFetch(input,options).finally(() => {pendingMutations--;schedule();});
  };
  const bypass = new WeakSet();
  const checkoutSelector = '[name="checkout"],#scala-button,a[href="/checkout"]';
  document.addEventListener('click',event => {
    const button = event.target.closest?.(checkoutSelector);
    if (!button) return;
    if (bypass.has(button)) {bypass.delete(button);return;}
    if (!running && !timer && !pendingMutations && document.documentElement.dataset.daljiBundleCart === 'ready') return;
    event.preventDefault();event.stopImmediatePropagation();
    const id=button.id, name=button.getAttribute('name');
    button.setAttribute('aria-busy','true');
    sync().then(() => {
      const live = id ? document.getElementById(id) : name ? document.querySelector(`[name="${name}"]`) : button;
      if (live) {bypass.add(live);live.click();}
    }).catch(() => {
      // Keep checkout available; Bundler's original checkout handler retries.
      const live = id ? document.getElementById(id) : button;
      if (live) {bypass.add(live);live.click();}
    }).finally(() => button.removeAttribute('aria-busy'));
  },true);
  document.addEventListener('cart:updated',schedule);
  document.addEventListener('product:added',schedule);
  window.DaljiBundleCart = {sync};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
})();

// Keep Scala's native payment button and provide its supported message slot.
(() => {
  if (window.daljiPaymentLabelsReady) return;
  window.daljiPaymentLabelsReady = true;
  let queued = false;
  function updatePaymentLabels() {
    queued = false;
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      const price = drawer.querySelector('.dalji-cart-pix__total strong');
      drawer.querySelectorAll('.drawer__footer-buttons scala-cart-button').forEach(host => {
        if (!price) {
          host.querySelector('[data-dalji-pix-message]')?.remove();
          return;
        }
        const amount = price.textContent.trim();
        let message = host.querySelector('[data-dalji-pix-message]');
        if (message && message.dataset.amount === amount) return;
        if (!message) {
          message = document.createElement('span');
          message.slot = 'message';
          message.dataset.daljiPixMessage = '';
          host.appendChild(message);
        }
        message.dataset.amount = amount;
        const label = document.createElement('span');
        label.textContent = 'Pagar com Pix';
        const value = document.createElement('strong');
        value.textContent = amount;
        message.replaceChildren(label, document.createTextNode(' – '), value);
      });
    });
  }
  function schedulePaymentLabels() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(updatePaymentLabels);
  }
  function startPaymentLabels() {
    updatePaymentLabels();
    new MutationObserver(schedulePaymentLabels).observe(document.body, {childList: true, subtree: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startPaymentLabels, {once: true});
  else startPaymentLabels();
})();
